import { Box } from '@mui/material'
import DescribedLabel from '~/src/components/utils/form/DecribedLabel'
import PushNotificationSwitch from '~/src/components/PushNotificationSwitch'
import { useTranslations } from '~/src/hooks/useTranslations'

const MarketingPreferencesPushNotification = () => {
  const { t } = useTranslations()

  return (
    <>
      <Box sx={{ gridArea: 'push-notifications' }}>
        <DescribedLabel
          label={t('profile.marketing.pushNotifications')}
          description={t('profile.marketing.pushNotificationsDescription')}
        />
      </Box>
      <Box sx={{ gridArea: 'push-notifications-toggle' }}>
        <PushNotificationSwitch />
      </Box>
    </>
  )
}

export default MarketingPreferencesPushNotification
